import { isNil } from 'lodash-es';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { API_ENDPOINT } from '../../resources/@types/apiEndpoint';
import { ResponseStatus, useClientApiV1UsersIdSlugQuery } from '../../resources/@types/uccSchema';
import { ApiError } from '../../resources/ApiError';
import { INFLEARN_URL, USERS_URL } from '../constants/urls';
import { useCurrentUrl } from './useCurrentUrl';
import useQueryParams from './useQueryParams';

export default function useRedirectCorrectSlug() {
  const router = useRouter();
  const { currentUrlWithoutQueryString } = useCurrentUrl();

  const { id: userId, slug } = useQueryParams();

  const { data, error } = useClientApiV1UsersIdSlugQuery({
    url: API_ENDPOINT.CLIENT_V1_USERS_ID_SLUG(String(userId)),
    queryKey: [API_ENDPOINT.CLIENT_V1_USERS_ID_SLUG(String(userId))],
    options: {
      enabled: Boolean(userId),
    },
  });

  useEffect(() => {
    if (isNil(data)) {
      return;
    }

    const isNotMatchSlug = data.slug !== slug;

    if (isNotMatchSlug) {
      void router.replace(USERS_URL.HOME({ userId: String(userId), slug: data?.slug }));
    }
  }, [data]);

  useEffect(() => {
    if (isNil(error)) {
      return;
    }
    const href = USERS_URL.HOME({ userId: String(userId) });

    const isProfileHomePage = currentUrlWithoutQueryString === href;
    const isNotValidUser =
      error instanceof ApiError && error.statusCode === ResponseStatus.BAD_PARAMETER;

    if (isNotValidUser) {
      void router.push(INFLEARN_URL.NOT_FOUND());
    }

    if (!isProfileHomePage) {
      void router.replace(href);
    }
  }, [error]);
}
